import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=1a4217d0&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user_center.css?vue&type=style&index=0&id=1a4217d0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4217d0",
  null
  
)

export default component.exports